import {
  UPDATE_AE_DETAILS_CHANGE,
  RESET_AE_DETAILS_CHANGE,
  UPDATE_AE_RESOURCE_LEVEL_ID,
  UPDATE_PROJECT_HEALTH_ID,
  UPDATE_AE_NOTES,
  UPDATE_PROJECT_WAIVER
} from './constants'
import { createReducer } from 'helpers/ReducerUtil'
import { combineReducers } from 'redux'

const updateAEDetailsChange = (prevDetails, { details }) => Object.assign({}, details)

const updateAEResourceLevelId = (prevDetails, { id }) => 
  ({ ...prevDetails, aeResourceLevelId: id })

const updateProjectHealthId = (prevDetails, { id }) => 
  ({ ...prevDetails, projectHealthId: id })

const updateAENotes = (prevDetails, { notes }) => 
({ ...prevDetails, aeNotes: notes })

const updateProjectWaiver = (prevDetails, { projectWaiver }) => 
({ ...prevDetails, projectWaiver: projectWaiver })

const aeDetailsChangeReducer = createReducer({}, {
  [RESET_AE_DETAILS_CHANGE]: () => {},
  [UPDATE_AE_DETAILS_CHANGE]: updateAEDetailsChange,
  [UPDATE_AE_RESOURCE_LEVEL_ID]: updateAEResourceLevelId,
  [UPDATE_PROJECT_HEALTH_ID]: updateProjectHealthId,
  [UPDATE_AE_NOTES]: updateAENotes,
  [UPDATE_PROJECT_WAIVER]: updateProjectWaiver
})

export default combineReducers({
  aeDetailsChange: aeDetailsChangeReducer
})
